import { motion } from "framer-motion";
import CountUp from "react-countup";
import {
  FiCheckCircle,
  FiActivity,
  FiHeart,
  FiUser,
  FiClock,
  FiSmile,
  FiMapPin,
  FiFolder,
} from "react-icons/fi";

export default function AboutUs() {
  return (
    <div className=" text-gray-800">

      <div className="text-center mt-28 mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl font-extrabold text-gray-800 mb-4"
        >
         About <span className="text-orange-500">Us</span>
        </motion.h2></div>
      
        
        <div className="inset-0 md:flex items-center justify-center">
  <p className="text-4xl font-semibold text-center text-gray-700">
    Let’s build it together — your <span className="text-orange-500">vision</span>, our <span className="text-orange-500">expertise</span>.
  </p>
</div>
     

      {/* Mission & Vision */}
      <div className="py-20 px-6 md:px-16 grid md:grid-cols-2 gap-12">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="bg-white p-8 rounded-2xl shadow-lg"
        >
          <h2 className="text-2xl font-semibold text-center mb-4">Our Vision</h2>
          <p className="text-center">
            Our Vision is to provide world-class solutions that empower businesses and individuals to achieve their goals efficiently and effectively.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="bg-white p-8 rounded-2xl shadow-lg"
        >
          <h2 className="text-2xl font-semibold text-center mb-4">Our Expertise</h2>
          <p className="text-center">
            We specialize in crafting a future where technology and creativity unite to ensure every project succeeds and every client is truly satisfied.
          </p>
        </motion.div>
      </div>

      {/* Team Section */}
      {/* <section className="py-20 px-6 md:px-16 bg-gray-100">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-3xl md:text-4xl font-bold text-center mb-12"
        >
          Meet Our Team
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {["Alice", "Bob", "Charlie"].map((name, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center"
            >
              <div className="w-32 h-32 bg-orange-200 rounded-full mb-4 flex items-center justify-center text-3xl font-bold text-white">
                {name[0]}
              </div>
              <h3 className="text-xl font-semibold mb-2">{name}</h3>
              <p className="text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna.
              </p>
            </motion.div>
          ))}
        </div>
      </section> */}

      <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="bg-gradient-to-r from-gray-700 to-orange-500 text-white py-20 mt-10"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 text-center gap-6 md:gap-10 px-6">
        
        {/* Years of Experience */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-lg transition"
        >
          <FiSmile className="mx-auto text-5xl text-white mb-3" />
          <h3 className="text-4xl md:text-5xl font-extrabold">
            <CountUp end={7} duration={3} />+
          </h3>
          <p className="mt-2 text-lg font-medium">Years of Experience</p>
        </motion.div>

        {/* Clients */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-lg transition"
        >
          <FiUser className="mx-auto text-5xl text-white mb-3" />
          <h3 className="text-4xl md:text-5xl font-extrabold">
            <CountUp end={90} duration={3} />+
          </h3>
          <p className="mt-2 text-lg font-medium">Clients</p>
        </motion.div>

        {/* Employees */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-lg transition"
        >
          <FiClock className="mx-auto text-5xl text-white mb-3" />
          <h3 className="text-4xl md:text-5xl font-extrabold">
            <CountUp end={25} duration={3} />+
          </h3>
          <p className="mt-2 text-lg font-medium">Employees</p>
        </motion.div>

        {/* Branches */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-lg transition"
        >
          <FiMapPin className="mx-auto text-5xl text-white mb-3" />
          <h3 className="text-4xl md:text-5xl font-extrabold">
            <CountUp end={2} duration={3} />+
          </h3>
          <p className="mt-2 text-lg font-medium">Branches</p>
        </motion.div>

        {/* Projects */}
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-lg transition"
        >
          <FiFolder className="mx-auto text-5xl text-white mb-3" />
          <h3 className="text-4xl md:text-5xl font-extrabold">
            <CountUp end={137} duration={3} />+
          </h3>
          <p className="mt-2 text-lg font-medium">Projects</p>
        </motion.div>
      </div>
    </motion.div>

      

      {/* Call to Action */}
      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="py-20 px-6 md:px-16 bg-gray-500 text-white text-center rounded-tl-3xl rounded-tr-3xl mt-12"
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Join Us On Our Journey</h2>
        <p className="mb-6 max-w-2xl mx-auto">
          We are always looking for talented individuals to be part of our growing team. Together, we achieve greatness.
        </p>
        <a href="https://www.linkedin.com/company/x7-it-technologies/" target="_blank" rel="noopener noreferrer">
        <button className="bg-white text-orange-500 font-semibold px-8 py-3 rounded-full hover:bg-gray-100 transition-transform hover:scale-105 duration-300">
          Contact Us
        </button>
        </a>
      </motion.section>
    </div>
  );
}
